import { LinkWithChevron } from '#components/Link/LinkWithChevron';

import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';

import { NewsPlayer } from './NewsPlayer';
import { ShortNewsArticlesLinks } from './ShortNewsArticlesLinks';
import styles from './Shortnews.module.scss';
import type { NewsAudioFragment } from './__generated__/Shortnews.generated';
import type { ShortnewsArticleFragment } from './fragments/__generated__/ShortnewsArticle.generated';

type Props = {
	timestamp: string | null;
	formattedDate: string | null;
	shortNewsList: Omit<ShortnewsArticleFragment, '__typename'>[];
	newsAudio: NewsAudioFragment | null;
};

export function Shortnews({ formattedDate, shortNewsList, timestamp, newsAudio }: Props) {
	return (
		<SingleColumnLayout contentClassName={styles.content}>
			<h1 className={styles.titlePrimary}>Die aktuellen Meldungen von BR24 im Überblick</h1>

			{formattedDate ? (
				<time className={`body6 ${styles.timestamp}`} dateTime={timestamp ?? undefined}>
					Stand: {formattedDate}
				</time>
			) : null}

			<section className={styles.links}>
				{shortNewsList.length === 0 ? (
					<p>Es konnten keine Nachrichten gefunden werden.</p>
				) : (
					<ShortNewsArticlesLinks className={styles.list} shortNewsList={shortNewsList} />
				)}
			</section>

			<NewsPlayer className={styles.player} audio={newsAudio} />

			<LinkWithChevron className={`heading3 ${styles.homepageLink}`} href="/">
				Zur BR24 Startseite
			</LinkWithChevron>
		</SingleColumnLayout>
	);
}
